<template>


		<div class="investment-solutions-carousel row m-0 w-100 h-100">

			<div class="d-md-none col-12 pr-0 pl-0">
				<transition name="investment-solutions-imgs" mode="out-in">
				<bordered-image-mobile v-for="(slide, index) in slides" :key="slide.id + '-img'" :url="slide.featureImage" v-if="index == currentSlide" height="140px"></bordered-image-mobile>
				</transition>
			</div>

			<div class="investment-solutions-carousel-content col-12 col-md-5 px-4 pl-md-5 pr-md-0 d-flex flex-column ">

				<ul class="investment-solutions-carousel-dots d-flex flex-column " :style="dotContainerStyle">
					<li class="investment-solutions-carousel-dot" v-for="(slide, index) in slides" :key="slide.title" :class="{ active: index == currentSlide }" @click.prevent.stop="clickedTitle(slide, index)">
					</li>
				</ul>

				<ul class="investment-solutions-items pt-4 px-4 px-md-0 pt-md-0">
					<li class="investment-solutions-item" v-for="(slide, index) in slides" :key="slide.headline" :class="{ active: index == currentSlide }">

						<h3 class="heading-2">
							<a href="#" @click.prevent.stop="clickedTitle(slide, index)">
								{{slide.headline}}
							</a>
						</h3>
						<div class="investment-solutions-item-content">
							<p v-html="slide.copy"></p>
							<h-button v-if="slide.ctaUrl != ''" :url="slide.ctaUrl" class="mb-4">{{slide.ctaText}}</h-button>
						</div>
					</li>

				</ul>

			</div>

			<div class="investment-solutions-carousel-desktop-imgs d-none d-md-block col-12 col-md-7 pr-0">
				<transition name="investment-solutions-imgs" mode="out-in">
				<bordered-image v-for="(slide, index) in slides" :key="slide.headline + '-img'" :url="slide.featureImage" v-if="index == currentSlide"></bordered-image>
				</transition>
			</div>
		</div>

</template>


<style lang="scss">
.unlocked {
	.investment-solutions-carousel .investment-solutions-item .investment-solutions-item-content {
		transition: none !important;
	}
}
.investment-solutions-carousel {
	position: relative;

	.investment-solutions-carousel-content {
		justify-content: center;

		@include respond-below(md) {
			height: 100%;
			justify-content: start;
		}
	}

	.investment-solutions-carousel-dots {
		position: absolute;
		left: 15px;
		top: 50%;
		justify-content: space-between;
		.investment-solutions-carousel-dot {
			cursor: pointer;
			display: block;
			border-radius: 50%;
			width: 10px;
			height: 10px;
			background-color: $lightGrey;
			transition: background-color 0.3s;

			&.active {
				background-color: $navyBlue;
			}
		}
		@include respond-below(md) {
			top: 30px;
		}
	}

	.investment-solutions-items{
		@include respond-below(md) {
			background-color:$white;
			margin-top: -75px;
		}
	}


	ul {
    	padding-left: 0;
    	list-style: none;
    	margin: 0;
    	padding: 0;
    	li {
    		list-style: none;
    	}
	}

	.investment-solutions-item {
		h3 {
			opacity: 0.5;	
			transition: all 0.3s ease;
			font-size: rem(24);

			@media (max-height: 700px) and (max-width: 700px) {
				font-size: rem(20);
				line-height: 1.25 !important;
			}

		}

		.investment-solutions-item-content {
			max-height: 0px;
			transition: all 0.5s ease;
			overflow: hidden;
			opacity: 0.0;

			@media (max-width: 375px) {
				p {
					line-height: 1.5;
					font-size: 0.95em;
				}
			}
		}

		&.active {
			h3 {
				opacity: 1.0;
				font-size: rem(48);

				@include respond-below(sm) {
					font-size: rem(36);
				}
			}

			.investment-solutions-item-content {
				max-height: 270px;
				opacity: 1.0;
			}

		}

		
	}
	// .investment-solutions-list-enter-active, .investment-solutions-list-leave-active {
	//   transition: opacity .3s ease;
	// }
	// .investment-solutions-list-enter, .investment-solutions-list-leave-to
	// {
	//   opacity: 0;
	// }


	.investment-solutions-imgs-enter-active, .investment-solutions-imgs-leave-active {
	  transition: opacity .15s ease, transform 0.30s ease, left 0.45s;	// left is a dummy to fix vue animation issue
	  .bordered-image-border {
	  	transition: all 0.30s ease;
	  	transition-delay: 0.15s;
	  }
	}
	.investment-solutions-imgs-enter, .investment-solutions-imgs-leave-to
	{
	  opacity: 0;
	  transform: translate(-100px, 0);

		.bordered-image-border {

			width: 0px;
		}
	}

	// tablet size
	.investment-solutions-carousel-desktop-imgs {
		@media (min-width: 767px) and (max-width: 1025px) {
		    justify-content: center;
		    display: flex !important;
		    align-items: center;

		    .bordered-image {
		    	max-height: 500px;
		    	max-width: 90%;
		    }
		}
	}
}


</style>

<script>
    import HButton from '../components/HButton.vue';
    import BorderedImage from '../components/BorderedImage.vue'
    import BorderedImageMobile from '../components/BorderedImageMobile.vue'

    export default {
        components: {
            HButton,
            BorderedImage,
            BorderedImageMobile,
        },
        mounted() {

            var parentElem = document.getElementById("investment-solutions-section");

            if (parentElem) {
                var nodeId = parentElem.dataset.carouselId.toLowerCase();
                this.$axios.get(this.cultureCode.toLowerCase() + '/verticalscroll/' + nodeId)
                    .then((response) => {
                        this.slides = response.data.slides;
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            }
        },
        data() {
            return {
                slides: [

                ]
            }
        },
        props: {
            progress: {
                type: Number,
                default: 0.0
            },
            cultureCode: {
                type: String,
                default: "en-US"
            }
        },
        computed: {
            currentSlide() {
                return Math.min(Math.floor(this.progress * (this.slides.length)), (this.slides.length - 1))
            },
            dotContainerStyle() {
                var szTransform = "";

                if (window.matchMedia("(min-width: 768px)").matches) {
                    szTransform = 'translateY(' + (-20 * this.slides.length) + 'px )';	// half height
                }

                return {
                    height: (40 * this.slides.length) + "px",
                    transform: szTransform
                }
            }
        },
        methods: {
            clickedTitle(slide, index) {
                this.$parent.scrollTo((index + 0.01) / (this.slides.length));
            }
        }
    }
</script>